export default {"src":"/_next/static/media/9-wsj-logo.c82876a5.svg","height":18,"width":212};